import React, { Component } from 'react';

class Messages extends Component {
    render() {
        return (
            <div style={{ padding: "0px 30px" }}>
                <div className="tile box-shadow-style">
                    <div className="row">
                        <div className="col-md-12 col-sm-12">
                            <div className="row">
                                <div className="col-md-4 text-center tilepadding">
                                    <label className="tilecontent">From</label>
                                </div>


                                <div className="col-md-4 text-center tilepadding">
                                    <label className="tilecontent">Subject</label>
                                </div>


                                <div className="col-md-4 text-center tilepadding">
                                    <label className="tilecontent">Received</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Messages;


// WEBPACK FOOTER //
// ./src/components/myprofile/messages.jsx